import React from 'react';
import { Box, Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import { differenceInDays } from '@shared/utils/date';

import { militaryTime } from '@/lib/date';
import Flight from '@/propTypes/Flight';

const getFlightsSchedule = (flights) => {
  const firstFlight = flights[0];
  const lastFlight = flights[flights.length - 1];

  const { departure } = firstFlight;
  const { arrival } = lastFlight;

  const departureTime = militaryTime(departure.time);
  const arrivalTime = militaryTime(arrival.time);
  const departureArrivalTime = `${departureTime} - ${arrivalTime}`;

  const daysDifference = differenceInDays(
    new Date(arrival.date),
    new Date(departure.date),
  );

  return {
    departureArrivalTime,
    departure,
    arrival,
    daysDifference,
  };
};

const DepartureArrivalTime = ({ flights, ...props }) => {
  const { departureArrivalTime, daysDifference } = getFlightsSchedule(flights);

  return (
    <Flex
      alignItems="flex-start"
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    >
      {departureArrivalTime}
      {daysDifference > 0 && (
        <Box fontSize="0.7em" fontWeight="normal">{` +${daysDifference}`}</Box>
      )}
    </Flex>
  );
};

DepartureArrivalTime.propTypes = {
  flights: PropTypes.arrayOf(PropTypes.shape(Flight)).isRequired,
};

export default DepartureArrivalTime;
